import React from "react";
import {Button,Modal} from 'react-bootstrap';

// import image_settings from '../../image_settings.json';
// import settings from '../../settings.json';


import MatchWidget from "./matchwidget";
import "./css/common.css"
// import Header from "./header"
import { withTranslation } from 'react-i18next';
import { StateAmbContext } from "../../stateContext";

//import Header from "./header"
// import Modal from "react-modal";
class Match extends React.Component {
    static contextType = StateAmbContext;
    state = {
        factorPopupOpen:false,
        factorPopupMessage:"",
    }
    
    togglePopup =()=>{
        const {t} = this.props;
        let application = this.props.tool === "Evaporator"?this.props.UC.temp:this.props.CU.temp;
        let sst = this.props.tool === "Evaporator"?this.props.UC.sst:this.props.CU.sst;
        let room_temp = (sst ===25?35:30);
        let factorMessage = "";
        if(application==="Medium Temp (Cooler)"){
            if(room_temp === 35){
                factorMessage = <div>
                <h4>{t('popups.ambsst.typical.rt_35.title')}</h4>
                <p>{t('popups.ambsst.typical.rt_35.desc')}</p>
                <p>{t('popups.ambsst.typical.rt_35.p1')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l1')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l2')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l3')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l4')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l5')}</li>
                </ol>
                <p>{t('popups.ambsst.typical.rt_35.p2')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.typical.rt_35.p2_l1')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p2_l2')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p2_l3')}</li>
                </ol>
                <p>{t('popups.ambsst.typical.rt_35.p3_1')}</p><p>{t('popups.ambsst.typical.rt_35.p3_2')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.typical.rt_35.p3_l1')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p3_l2')}</li>
                </ol>
                <p>{t('popups.ambsst.typical.rt_35.p4')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.typical.rt_35.p4_l1')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p4_l2')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p4_l3')}</li>
                </ol>
                <h4>{t('popups.ambsst.heavy.title_rt_35')}</h4>
                <p>{t('popups.ambsst.heavy.rt_35.desc')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.heavy.rt_35.p1_l1')}</li>
                    <li> {t('popups.ambsst.heavy.rt_35.p1_l2')}</li>
                </ol>
                <p>{t('popups.ambsst.heavy.rt_35.p2')}</p>
                <p>{t('popups.ambsst.heavy.rt_35.p3')}</p>
            

            
            
            </div>;
            }else{
                factorMessage = <div>
                                    <h4>{t('popups.ambsst.typical.rt_other.title')}</h4>
                                    <p className="popheader1">{t('popups.ambsst.typical.rt_other.desc')}</p>
                                    <p className="popheader2">{t('popups.ambsst.typical.rt_other.p1')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l1')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l2')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l3')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l4')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l5')}</li>
                                    </ol>
                                    <p className="popheader1">{t('popups.ambsst.typical.rt_other.p2')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.typical.rt_other.p2_l1')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p2_l2')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p2_l3')}</li>
                                    </ol>
                                    <p className="popheader1">{t('popups.ambsst.typical.rt_other.p3_1')}</p><p>{t('popups.ambsst.typical.rt_other.p3_2')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.typical.rt_other.p3_l1')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p3_l2')}</li>
                                    </ol>
                                    <p className="popheader1">{t('popups.ambsst.typical.rt_other.p4')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.typical.rt_other.p4_l1')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p4_l2')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p4_l3')}</li>
                                    </ol>
                                    <h4>{t('popups.ambsst.heavy.rt_other.title')}</h4>
                                    <p className="popheader1">{t('popups.ambsst.heavy.rt_other.desc')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.heavy.rt_other.p1_l1')}</li>
                                        <li> {t('popups.ambsst.heavy.rt_other.p1_l2')}</li>
                                    </ol>
                                    <p className="popheader1">{t('popups.ambsst.heavy.rt_other.p2')}</p>
                                    <p style={{textAlign:"justify"}}>{t('popups.ambsst.heavy.rt_other.p3')}</p>


                                
                                
                                </div>
            }
        }else if(application === "Low Temp (Freezer)"){
            factorMessage = <div>
            <h4>{t('popups.ambsst.typical.app_lt.title')}</h4>
            <p>{t('popups.ambsst.typical.app_lt.desc')}</p>
            <p>{t('popups.ambsst.typical.app_lt.p1')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.typical.app_lt.p1_l1')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p1_l2')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p1_l3')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p1_l4')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p1_l5')}</li>
            </ol>
            <p>{t('popups.ambsst.typical.app_lt.p2')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.typical.app_lt.p2_l1')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p2_l2')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p2_l3')}</li>
            </ol>
            <p>{t('popups.ambsst.typical.app_lt.p3_1')}</p><p>{t('popups.ambsst.typical.app_lt.p3_2')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.typical.app_lt.p3_l1')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p3_l2')}</li>
            </ol>
            <p>{t('popups.ambsst.typical.app_lt.p4')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.typical.app_lt.p4_l1')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p4_l2')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p4_l3')}</li>
            </ol>
            <h4>{t('popups.ambsst.heavy.app_lt.title')}</h4>
            <p>{t('popups.ambsst.heavy.app_lt.desc')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.heavy.app_lt.p1_l1')}</li>
                <li> {t('popups.ambsst.heavy.app_lt.p1_l2')}</li>
            </ol>
            <p>{t('popups.ambsst.heavy.app_lt.p2')}</p>
            <p>{t('popups.ambsst.heavy.app_lt.p3')}</p>



        
        
        </div> ;
        }
        this.setState({"factorPopupOpen":!this.state.factorPopupOpen,"factorPopupMessage":factorMessage})
    }
      

    render() {
        const {t} = this.props; 
        const { stateAmb,updateStateAmb, settings,image_settings }  = this.context;
 
        var cumodel = this.props.CU.models.find((e) => {
            if (this.props.CU.selected_model == e.model)
                return e;
        });
        var ucmodel = this.props.UC.models.find((e) => {
            if (this.props.UC.selected_model == e.model)
                return e;
        });

        var ucmodel_option = ucmodel.option_packages.find((e) => {
            if (this.props.UC.selected_option == e.code)
                return e;
        });

        var cumodel_option = cumodel.option_packages.find((e) => {
            if (this.props.CU.selected_option == e.code)
                return e;
        });
        var dataSysBal = ( this.props.tool==="System"? {"sysBal":cumodel.btuh,"cal_td":ucmodel.calculated_td,...stateAmb} :{"sysBal":0,"cal_td":0,...stateAmb});
        return (    
        <>
        {/* <Header /> */}
        <div className="row m-0">
            <div className="col-sm-12  bg-head mb-3">
                <div className="custom_container p-0">
                <p className="p_select">{t('matchpages.pdt_selector')}</p>
                <b className="font32">{(this.props.tool === "System") ? <>{t('unit_names.system')}</> : <>{this.props.tool}</>}</b>
                </div>
            </div>
            <div className="custom_container m-auto p-0 ">
            <div onClick={this.togglePopup} className="infobtn"  ><p><i className="fa fa-info-circle" aria-hidden="true"></i>{t('ambsst_Ques.modal_title')}</p>
            
            <Modal show={this.state.factorPopupOpen} onHide={this.togglePopup}>
                <Modal.Header closeButton>
                <Modal.Title>{t('ambsst_Ques.modal_title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body><p style={{fontSize:"smaller"}}>{t('ambsst_Ques.modal_body')}{this.state.factorPopupMessage}</p></Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={this.togglePopup}>
                {t('common.close')}
                </Button>
                </Modal.Footer>
            </Modal>
        
            </div>
                <div className="row">
                    <div className="col-sm-12 mb18 mlr11">
                    <div hidden={this.props.tool==="System"?false:true} className="res_ma" data-amb={JSON.stringify(dataSysBal)} >
                    {(this.props.tool ==="System")?<span>{t('matchpages.sys_bal')} {cumodel.btuh.toLocaleString()} {t('ambsst_Ques.btu_header')} @ {(Number(ucmodel.calculated_td)).toFixed(2)}ºF {t('matchpages.td')}</span>:<></>}
                    
                </div>
                        <div className="row">
                            {(this.props.tool === "Evaporator") ?
                                <div className="col-sm-12 ">
                                    <MatchWidget
                                        model={ucmodel}
                                        updateOption={this.props.update_uc}
                                        selected_option={ucmodel_option}
                                        selected_option_code = {this.props.UC.selected_option}
                                        head="Evaporator"
                                        img={settings.image_path + image_settings.uc_img}
                                        price = {this.props.UC.total_price}
                                        navigate = {this.props.navigate}
                                        headback = {"builduc"}
                                        condn_units_count={1}
                                        a2lSelectRef={this.props.UC.ref}
                                        a2lAmin={this.props.UC.aMin}
                                    />
                                </div> : <></>}
                            {(this.props.tool === "Condensing Unit") ?
                                <div className="col-sm-12 p-0">
                                    <MatchWidget
                                        model={cumodel}
                                        updateOption={this.props.update_cu}
                                        selected_option={cumodel_option}
                                        selected_option_code = {this.props.CU.selected_option}
                                        head="Condensing Unit"
                                        img={settings.image_path + image_settings.cu_img}
                                        price = {this.props.CU.total_price}
                                        navigate = {this.props.navigate}
                                        headback = {"buildcu"}
                                        condn_units_count={1}
                                    />
                                </div> : <></>}
                            {(this.props.tool === "System") ? <>
                                <div className="col-sm-6 pl12">
                                    <MatchWidget
                                        model={cumodel}
                                        updateOption={this.props.update_cu}
                                        selected_option={cumodel_option}
                                        selected_option_code = {this.props.CU.selected_option}
                                        head="Condensing Unit"
                                        img={settings.image_path + image_settings.cu_img}
                                        price = {this.props.CU.total_price}
                                        navigate = {this.props.navigate}
                                        headback = {"re-buildsystem-cu"}
                                        condn_units_count={1}
                                    />
                                </div>
                                <div className="col-sm-6 pr12">
                                    <MatchWidget
                                        model={ucmodel}
                                        updateOption={this.props.update_uc}
                                        selected_option={ucmodel_option}
                                        selected_option_code = {this.props.UC.selected_option}
                                        head="Evaporator"
                                        img={settings.image_path + image_settings.uc_img}
                                        price = {this.props.UC.total_price/this.props.CU.count}
                                        navigate = {this.props.navigate}
                                        headback = {"re-buildsystem-uc"}
                                        condn_units_count={this.props.CU.count}

                                    />
                                </div> </> : <></>}
                        </div>
                    </div>
                    <div className="col-sm-12 palr11">
                    <div className="bg-blue total-btn"><b>{t('common.Total')}: { (String(this.props.match.total_price_counts)==="0" || String(this.props.match.total_price_counts)==="NaN")? "-" : "$" + this.props.match.total_price_counts.toLocaleString() }</b></div>
                   
                    <div className="btn_main_st mb-3">
                        {settings.is_hub?<div className="bg-blue btns print-btn-left" onClick={() => { try{window.HC.Selection.cancelToQuote()}catch(err){var a = err;}  }}><b>Cancel</b></div>:<></>}
                        <div className="bg-blue btns print-btn-left smright" onClick={() => {  this.props.navigate("prev") }} ><i className="fa  fa-angle-left"></i><b> Back</b></div>
                        {settings.is_hub?<></>:<div className="bg-blue btns print-btn-right" onClick={() => { window.print() }}><i className="fa fa-print"></i> <b>{t('common.Print')}</b></div>}
                        {settings.is_hub?<div className="bg-blue btns print-btn-right"  onClick={() => { try{window.HC.Selection.addSSAToQuote()}catch(err){var a=err;} }}><i className="fa fa-plus"></i> <b>Add to Quote</b></div>:<></>}
                        <div className="bg-blue btns print-btn-center" onClick={() => { this.props.navigate("start-over") }}><i className="fa  fa-rotate-right"></i> <b>Start Over</b></div>
                    </div>
                   
                   
                   
                        {/* <div className="bg-deepblue p30 ">
                            <div className="lessmore ">^</div>
    <div type="button" className="next-pre-btn btn-white btn-sm mb-2 fullwidth">Total: ${this.props.match.total_price_counts.toLocaleString() }</div>
                            <div type="button" className="next-pre-btn btn-blue btn-sm mb-2 bluest1 fullwidth" onClick={() => { window.print() }}>Print</div>
                            <div type="button" className="next-pre-btn btn-blue btn-sm mb-2 bluest1 fullwidth" onClick={() => { this.props.navigate("prev") }}>Previous</div>
                            <div type="button" className="next-pre-btn btn-blue btn-sm mb-2 bluest1 fullwidth" onClick={() => { this.props.navigate("start-over") }}>Start Over</div>
                        </div> */}
                    </div>
                </div>
            </div>

        </div></>)
    }
}
export default withTranslation() (Match);